import classNames from 'classnames'
interface DotsLoadingProps {
    extraStyleCircle?: string
}
const DotsLoading = ({ extraStyleCircle }: DotsLoadingProps) => {
    return (
        <div className="flex w-full items-center justify-center">
            <div className="flex items-center h-6 gap-2">
                <div
                    className={classNames(
                        'flex h-3 w-3 bg-current rounded-full delay-0	 align-[-0.125em] animate-[bounce_1s_ease-in-out_infinite] animation_delay_one',
                        extraStyleCircle
                    )}
                />
                <div
                    className={classNames(
                        'flex h-3 w-3 bg-current rounded-full delay-500  align-[-0.125em] animate-[bounce_1s_ease-in-out_infinite] animation_delay_two',
                        extraStyleCircle
                    )}
                />
                <div
                    className={classNames(
                        'flex h-3 w-3 bg-current rounded-full delay-1000 align-[-0.125em] animate-[bounce_1s_ease-in-out_infinite] animation_delay_three',
                        extraStyleCircle
                    )}
                />
            </div>
        </div>
    )
}

export default DotsLoading
